<template>
  <tbody>
    <tr
      v-for="(item, i) in items"
      :key="i"
      class="text-xs-center hovereable cursor-default">
      <td width="120">
        <v-avatar size="45" class="transparent pl-5">
          <v-icon large class="k-orange-linear-text">fas fa-money-bill-wave</v-icon>
        </v-avatar>
      </td>
      <td></td>
      <td>
        Registrado
        <small> <v-icon class="f0-9em">far fa-calendar-plus</v-icon> {{ formatDate(item.register_date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
      </td>
      <td>
        Pagado
        <small> <v-icon class="f0-9em">far fa-calendar-check</v-icon> {{ formatDate(item.payment_date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
      </td>
      <td class="text-xs-left">
        Referencia
        <small>#{{ item.reference }}</small>
      </td>
      <td>
        <p class="title">
          ${{ new Intl.NumberFormat('es-VE').format(item.amount) }}
        </p>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';

export default {
  props: ['items'],
  methods: {
    formatDate(date, typeFormat, toFormat) {
      return moment(date, typeFormat).format(toFormat);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center/PaymentsList.vue